import React, {Component} from 'react';
import Styles from './style.css';
import {langRegister} from "../../services/langRegister";
import cx from "classnames";
import {dataRegister} from "../../services/dataRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";

class Footer extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    };

    componentWillMount() {
        this._updateDate();
    }

    _updateDate(){
        let date = new Date();
        let year = date.getFullYear();
        this.setState({year: year});
    }

    _renderText(item) {
        return langRegister.get("footer", item);
    }

    render() {
        return (
            <div className={Styles.container}>
                <div className={Styles.containerInner}>
                    <div className={Styles.containerInnerContent}>
                        <div className={Styles.containerInnerContentText}>
                            <a className={Styles.containerInnerContentTextLink} target={"_blank"} href={'https://legal.'+ dataRegister.domain+"/"+salesChannelRegister.get('market')+ "/" + langRegister.lang() +"/"+ "terms" + "/" + salesChannelRegister.get('name')}>{this._renderText("item_19")}</a>{" "}|{" "}
                            <a className={Styles.containerInnerContentTextLink} target={"_blank"} href={'https://legal.'+ dataRegister.domain+"/"+salesChannelRegister.get('market')+ "/" + langRegister.lang() +"/"+ "privacy" + "/" + salesChannelRegister.get('name')}>{this._renderText("item_20")}</a>{" "}|{" "}
                            <a className={Styles.containerInnerContentTextLink} target={"_blank"} href={'https://legal.'+ dataRegister.domain+"/"+salesChannelRegister.get('market')+ "/" + langRegister.lang() +"/"+ "acceptance" + "/" + salesChannelRegister.get('name')}>{this._renderText("item_21")}</a>{" "}|{" "}©{" "}{this.state.year}{" "}saleschannel
                        </div>
                    </div>
                    <div className={Styles.containerInnerLogo}>
                        <img className={Styles.containerInnerLogoDesktop} src={salesChannelRegister.get('logo_dashboard')}/>
                    </div>
                </div>
            </div>
        );
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/footer/component.js